import {
  ApplicationRef,
  ComponentFactoryResolver,
  ComponentRef,
  Injectable,
  Injector,
} from '@angular/core';
import { FloatingUploadPreviewPanelComponent } from '../../components/floating-upload-preview-panel/floating-upload-preview-panel.component';

export interface FloatingUploadPreviewConfig {
  fileName: string;
  previewUrl: string;
  onClose?: () => void;
}

@Injectable({ providedIn: 'root' })
export class FloatingUploadPreviewService {
  private componentRef: ComponentRef<FloatingUploadPreviewPanelComponent> | null = null;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector,
  ) {}

  open(config: FloatingUploadPreviewConfig): void {
    if (!config.previewUrl?.trim()) {
      return;
    }

    this.close();

    const factory = this.componentFactoryResolver.resolveComponentFactory(
      FloatingUploadPreviewPanelComponent,
    );
    this.componentRef = factory.create(this.injector);
    const instance = this.componentRef.instance;
    instance.fileName = config.fileName;
    instance.previewUrl = config.previewUrl;
    instance.closed.subscribe(() => {
      config.onClose?.();
      this.close();
    });

    this.appRef.attachView(this.componentRef.hostView);
    const container = document.getElementById('global-overlay-filter');
    const rootNode = this.componentRef.location.nativeElement as HTMLElement;
    if (container && rootNode) {
      container.appendChild(rootNode);
    }
  }

  close(): void {
    if (!this.componentRef) {
      return;
    }
    this.appRef.detachView(this.componentRef.hostView);
    this.componentRef.destroy();
    this.componentRef = null;
  }

  isOpen(): boolean {
    return !!this.componentRef;
  }
}
